/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';
import { fetchPurchaseActivity } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function usePurchaseActivity() {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'purchaseActivity', userId, sessionId],
    queryFn: () => fetchPurchaseActivity(getToken),
    enabled: Boolean(userId),
    select: data => data.purchases
  });
}
